import React, { useState } from 'react'

import PropTypes from 'prop-types'
import OccupancyBarMinimal from '../components/OccupancyBarMinimal.js'
import './banner.css'

const Banner = (props) => {
  const [hover, setHover] = useState(true)
  return (
    <div
      id={props.bannerId}
      className={`banner-header30 thq-section-padding ${props.rootClassName} `}
    >
      <div id="2" className="banner-container1">
        <img
          alt="Avatar customization"
          sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
          src="/fitnes1-1500w.webp"
          loading="lazy"
          srcSet="/fitnes1-1500w.webp 1200w, /fitnes1-tablet.webp 800w, /fitnes1-mobile.webp 480w"
          className="banner-image imagefocus"
        />
      </div>
      <div className="banner-max-width thq-section-max-width">
        <div className="banner-content">
          <h2 className="banner-text1 thq-heading-1">
            Nastartuj svojí cestu k nejlepší formě
          </h2>
          <p className="banner-text2">
            <span>Zdokonalte své tělo s námi!</span>
            <br></br>
          </p>
        </div>
        <div className="banner-container2">
          <div>
            <div className="banner-container4">
            <OccupancyBarMinimal /> {}            
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Banner.defaultProps = {
  bannerId: '',
  rootClassName: '',
}

Banner.propTypes = {
  bannerId: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Banner
